import { cva } from 'class-variance-authority'

export const helperTextStyles = cva(
  ['first-letter:capitalize', 'rounded-base'],
  {
    variants: {
      size: {
        default: 'text-label-sm',
        compact: 'text-label-xs',
      },
      status: {
        neutral: 'text-content-subdued',
        warn: 'text-content-on-attention',
        error: 'text-content-on-negative',
      },
      highlighted: {
        true: ['p-3'],
        false: [],
      },
    },
    compoundVariants: [
      {
        status: 'neutral',
        highlighted: true,
        className: ['bg-surface-subdued'],
      },
      {
        status: 'warn',
        highlighted: true,
        className: ['bg-surface-attention'],
      },
      {
        status: 'error',
        highlighted: true,
        className: ['bg-surface-negative'],
      },
    ],
    defaultVariants: {
      size: 'default',
    },
  },
)
